// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./core/vue/css/secondary_page.css
// module id = 884
// module chunks = 17